import {useTheme} from '@mui/material';
import {ProjectContext} from '@context/ProjectContext';
import {useContext} from 'react';

export default function NavLinearGradient({active}: { active: boolean }) {
	const theme = useTheme();
	const {shahadat} = useContext(ProjectContext);

	if (shahadat) {
		const color = active ? '#000000' : theme.palette.grey[400];
		return (
			<>
				<stop stopColor={color}/>
				<stop offset="1" stopColor={color}/>
			</>
		);
	}

	// @ts-ignore
	const first = active ? theme.palette.primary[400] : theme.palette.grey[400];
	// @ts-ignore
	const second = active ? theme.palette.primary[600] : theme.palette.grey[400];
	return (
		<>
			<stop stopColor={first}/>
			<stop offset="1" stopColor={second}/>
		</>
	);
}
